export const DEFAULT_TIMEOUT_JOB_SAVING = 1000;
export const DEFAULT_TIMEOUT_JOB_SAVED = 500;
export const DEFAULT_TIMEOUT_SEND_VIEW_EVENT = 2000;
